import { defineMessages } from 'react-intl'

export default defineMessages({
  // Budget notifications
  deleteBudget: {
    id: 'app.notification.deleteBudget',
    defaultMessage: 'Delete budget {budgetName}',
    description: 'Notification title when deleting a budget',
  },
  removeFromBudget: {
    id: 'app.notification.removeFromBudget',
    defaultMessage: 'Remove from {budgetName}',
    description: 'Notification title when removing from a budget',
  },
  copyBudget: {
    id: 'app.notification.copyBudget',
    defaultMessage: 'Copy budget {sourceBudgetName} as {targetBudgetName}',
    description: 'Notification title when copying a budget',
  },
  importBalancesToBudget: {
    id: 'app.notification.importBalancesToBudget',
    defaultMessage: 'Import balances to budget {budgetName}',
    description: 'Notification title when importing balances to budget',
  },

  // Budget deletion descriptions
  deletingBudgetData: {
    id: 'app.notification.deletingBudgetData',
    defaultMessage: 'Deleting budget data',
    description: 'Notification description for deleting budget data',
  },
  deletingSubBudgets: {
    id: 'app.notification.deletingSubBudgets',
    defaultMessage: 'Deleting sub budgets',
    description: 'Notification description for deleting sub budgets',
  },
  deletingBudgetDataAndSubBudgets: {
    id: 'app.notification.deletingBudgetDataAndSubBudgets',
    defaultMessage: 'Deleting budget data & sub budgets',
    description:
      'Notification description for deleting budget data and sub budgets',
  },
  deletingBudgetAndSubBudgetsData: {
    id: 'app.notification.deletingBudgetAndSubBudgetsData',
    defaultMessage: 'Deleting budget & sub budgets data',
    description:
      'Notification description for deleting budget and sub budgets data',
  },
  importingSingleDimensionTarget: {
    id: 'app.notification.importingSingleDimensionTarget',
    defaultMessage: 'Importing to single dimension target',
    description:
      'Notification description for importing to single dimension target',
  },

  // Operative data notifications
  deleteAllOperativeData: {
    id: 'app.notification.deleteAllOperativeData',
    defaultMessage: 'Delete all operative data from {companyName}',
    description: 'Notification title when deleting all operative data',
  },

  // Voucher notifications
  deleteAllVouchers: {
    id: 'app.notification.deleteAllVouchers',
    defaultMessage: 'Delete all vouchers from {companyName}',
    description: 'Notification title when deleting all vouchers',
  },

  // Sub budget notifications
  importDataToSubBudget: {
    id: 'app.notification.importDataToSubBudget',
    defaultMessage: 'Import data to sub budget {subBudgetName}',
    description: 'Notification title when importing data to sub budget',
  },
  deleteSubBudget: {
    id: 'app.notification.deleteSubBudget',
    defaultMessage: 'Delete sub budget {subBudgetName}',
    description: 'Notification title when deleting a sub budget',
  },

  // Import descriptions
  importingAllDimensionTargets: {
    id: 'app.notification.importingAllDimensionTargets',
    defaultMessage: 'Importing to all dimension targets',
    description:
      'Notification description for importing to all dimension targets',
  },

  // Account notifications
  deleteAllAccounts: {
    id: 'app.notification.deleteAllAccounts',
    defaultMessage: 'Delete all accounts from {companyName}',
    description: 'Notification title when deleting all accounts',
  },

  // Actuals calculation
  actualsCalculation: {
    id: 'app.notification.actualsCalculation',
    defaultMessage: 'Actuals calculation',
    description: 'Notification title for actuals calculation',
  },
  calculatingTimerange: {
    id: 'app.notification.calculatingTimerange',
    defaultMessage: 'Calculating timerange {startDate} - {endDate}',
    description: 'Notification description for calculating timerange',
  },

  // Voucher notifications
  voucherIntegration: {
    id: 'app.notification.voucherIntegration',
    defaultMessage: 'Voucher integration',
    description: 'Notification title for voucher integration',
  },
  integratingVouchers: {
    id: 'app.notification.integratingVouchers',
    defaultMessage:
      'Integrating {voucherCount} vouchers with {lineCount} lines',
    description: 'Notification description for integrating vouchers',
  },
  deleteAllVouchersByClass: {
    id: 'app.notification.deleteAllVouchersByClass',
    defaultMessage: 'Delete all {voucherClass} vouchers from {companyName}',
    description: 'Notification description for deleting vouchers by class',
  },
  deleteVouchersMarkedDeleted: {
    id: 'app.notification.deleteVouchersMarkedDeleted',
    defaultMessage:
      'Delete all vouchers marked deleted by integration from {companyName}',
    description:
      'Notification description for deleting vouchers marked deleted',
  },

  // Dimension notifications
  dimensionDeleted: {
    id: 'app.notification.dimensionDeleted',
    defaultMessage: 'Dimension Deleted',
    description: 'Notification title when dimension is deleted',
  },
  dimensionDeletedDescription: {
    id: 'app.notification.dimensionDeletedDescription',
    defaultMessage: "Dimension '{dimensionName}' with values deleted",
    description: 'Notification description when dimension is deleted',
  },
  integratingDimensions: {
    id: 'app.notification.integratingDimensions',
    defaultMessage: 'Integrating dimensions',
    description: 'Notification title for integrating dimensions',
  },
  integratingDimensionsDescription: {
    id: 'app.notification.integratingDimensionsDescription',
    defaultMessage:
      'Integrating {dimensionCount} dimensions with {valueCount} values',
    description: 'Notification description for integrating dimensions',
  },

  // Invoice notifications
  invoiceIntegration: {
    id: 'app.notification.invoiceIntegration',
    defaultMessage: 'Invoice integration',
    description: 'Notification title for invoice integration',
  },
  integratingInvoices: {
    id: 'app.notification.integratingInvoices',
    defaultMessage: 'Integrating Invoices',
    description: 'Notification title for integrating invoices',
  },
  integratingInvoicesDescription: {
    id: 'app.notification.integratingInvoicesDescription',
    defaultMessage:
      'Integrating {invoiceCount} invoices of type {invoiceType} with {lineCount} lines',
    description: 'Notification description for integrating invoices',
  },
  deleteAllInvoices: {
    id: 'app.notification.deleteAllInvoices',
    defaultMessage: 'Delete all invoices from {companyName}',
    description: 'Notification description for deleting all invoices',
  },
  deleteInvoicesMarkedDeleted: {
    id: 'app.notification.deleteInvoicesMarkedDeleted',
    defaultMessage:
      'Delete all invoices marked deleted by integration from {companyName}',
    description:
      'Notification description for deleting invoices marked deleted',
  },

  // Operative data notifications
  operativeIntegration: {
    id: 'app.notification.operativeIntegration',
    defaultMessage: 'Operative integration',
    description: 'Notification title for operative integration',
  },
  deleteOperativeItemsMarkedDeleted: {
    id: 'app.notification.deleteOperativeItemsMarkedDeleted',
    defaultMessage:
      'Delete all Operative items marked deleted by integration from {companyName}',
    description:
      'Notification description for deleting operative items marked deleted',
  },

  // Status messages (Done/Fail methods)
  vouchersSaved: {
    id: 'app.notification.vouchersSaved',
    defaultMessage: 'Vouchers saved',
    description: 'Notification status when vouchers are saved successfully',
  },
  dimensionsSaved: {
    id: 'app.notification.dimensionsSaved',
    defaultMessage: 'Dimensions saved',
    description: 'Notification status when dimensions are saved successfully',
  },
  dimensionDeletedStatus: {
    id: 'app.notification.dimensionDeletedStatus',
    defaultMessage: 'Dimension deleted',
    description: 'Notification status when dimension is deleted successfully',
  },
  calculationDone: {
    id: 'app.notification.calculationDone',
    defaultMessage: 'Calculation done',
    description: 'Notification status when calculation is completed',
  },
  calculationCancelled: {
    id: 'app.notification.calculationCancelled',
    defaultMessage: 'Calculation cancelled successfully',
    description: 'Notification status when calculation is cancelled',
  },
  invoicesSaved: {
    id: 'app.notification.invoicesSaved',
    defaultMessage: 'Invoices saved',
    description: 'Notification status when invoices are saved successfully',
  },

  // Additional status messages
  accountsDeletedWithFailures: {
    id: 'app.notification.accountsDeletedWithFailures',
    defaultMessage:
      'Successfully deleted {successCount} accounts. {failureCount} deletions failed.',
    description:
      'Notification description when deleting accounts with some failures',
  },
  importingToAllDimensionTarget: {
    id: 'app.notification.importingToAllDimensionTarget',
    defaultMessage: 'Importing to all dimension target',
    description:
      'Notification description when importing to all dimension targets',
  },
  operativeItemsSaved: {
    id: 'app.notification.operativeItemsSaved',
    defaultMessage: 'Operative items saved',
    description:
      'Notification status when operative items are saved successfully',
  },
  deserializationFailed: {
    id: 'app.notification.deserializationFailed',
    defaultMessage: 'Deserialization failed',
    description: 'Notification error when data deserialization fails',
  },
  errorUpsertingDimensions: {
    id: 'app.notification.errorUpsertingDimensions',
    defaultMessage: 'Error upserting dimensions: {errorMessage}',
    description: 'Notification error when upserting dimensions fails',
  },
  errorMappingInvoices: {
    id: 'app.notification.errorMappingInvoices',
    defaultMessage: 'Error mapping InvoiceDtos to Invoices: {errorMessage}',
    description: 'Notification error when mapping invoice DTOs fails',
  },
  uncaughtException: {
    id: 'app.notification.uncaughtException',
    defaultMessage: 'Uncaught exception: {errorMessage}',
    description: 'Notification error for uncaught exceptions',
  },
  noVouchersToCalculate: {
    id: 'app.notification.noVouchersToCalculate',
    defaultMessage: 'No vouchers to calculate',
  },
  missingAccountCreated: {
    id: 'app.notification.missingAccountCreated',
    defaultMessage: 'Missing account created: {accountNumber}',
  },
  missingAccountSchemeRow: {
    id: 'app.notification.missingAccountSchemeRow',
    defaultMessage:
      'Missing AccountScheme row for accountNumber: {accountNumber}',
  },
  cannotFindPeriodValues: {
    id: 'app.notification.cannotFindPeriodValues',
    defaultMessage:
      'Cannot find current period and previous period values for Company: {companyName}, Period: {year} / {month}!',
  },

  // Integration notifications
  integrationRequested: {
    id: 'app.notification.integrationRequested',
    defaultMessage: 'Integration requested',
    description: 'Notification title when integration is requested',
  },
  startingIntegrationForMaterialTypes: {
    id: 'app.notification.startingIntegrationForMaterialTypes',
    defaultMessage:
      'Starting integration for material types {materialTypes}\n  Requesting data from source system. Please wait.',
    description:
      'Notification description when starting integration for material types',
  },
})
